export default __webpack_public_path__ + "static/media/service1.d62d4f84.jpg";